<template>
  <kt-panel>
    <form @submit.prevent="submitRequest"
          id="single-request-form"
          class="kt-form p-3 my-4"
    >
      <div class="container p-3 pt-5 my-4 border in-border-header" style="padding-top: 1.5rem !important;">
        <kt-form-section is_first>
          <div class="section-header">
            {{ $t('online-factor.create_field') }}
          </div>
          <kt-row class="p-2">
            <kt-col lg="12" md="12" xs="12">
              <kt-form-group>
                <kt-form-label for="fa_name">
                  {{ $t('online-factor.field_name') }}
                  <span class="text-danger h5 pb-3">*</span>
                </kt-form-label>
                <kt-form-control id="name" name="name" v-model="name">
                </kt-form-control>
              </kt-form-group>
            </kt-col>
            <kt-col lg="12" md="12" xs="12">
              <kt-form-group>
                <kt-form-label for="name">
                  {{ $t('online-factor.field_fa_name') }}
                  <span class="text-danger h5 pb-3">*</span>
                </kt-form-label>
                <kt-form-control id="fa_name" name="fa_name" v-model="fa_name">
                </kt-form-control>
              </kt-form-group>
            </kt-col>
            <kt-col lg="12" md="12" xs="12">
              <kt-form-group>
                <kt-form-label for="type">
                  {{ $t('online-factor.field_type') }}
                  <span class="text-danger h5 pb-3">*</span>
                </kt-form-label>
                <select id="type" class="form-control" name="type" v-model="type">
                  <option
                      v-for="type in fieldTypes"
                      :key="type.value"
                      :value="type.value"
                  >
                    {{type.fa_name}}
                  </option>
                </select>
              </kt-form-group>
            </kt-col>
            <kt-col lg="12" md="12" xs="12">
              <kt-form-group>
                <kt-form-label for="type">
                  {{ $t('online-factor.default_status') }}
                </kt-form-label>
                <select id="type" class="form-control" name="default_status" v-model="default_status.data">
                  <option
                      v-for="status in fieldStatus"
                      :key="status.name"
                      :value="status.name"
                  >
                    {{status.fa_name}}
                  </option>
                </select>
              </kt-form-group>
            </kt-col>
            <kt-col lg="12" md="12" xs="12">
              <kt-form-group class="d-flex justify-content-between align-items-center w-50">
                <kt-form-label for="type" class="mt-1">
                  {{ $t('online-factor.disable') }}
                  <span class="text-danger h5 pb-3">*</span>
                </kt-form-label>
                <input id="type" type="checkbox" class="check-mark" name="disable" v-model="disable.data">
              </kt-form-group>
            </kt-col>
            <kt-col
                lg="12" md="12" xs="12"
                v-if="[
                  fieldTypesConstants.DATE,
                  fieldTypesConstants.SELECT,
              ].includes(type)"
            >
              <kt-form-group>
                <kt-form-label for="default_value">
                  {{ $t('online-factor.default_value') }}
                </kt-form-label>
                <input
                    type="text"
                    class="form-control"
                    id="default_value"
                    name="default_value"
                    aria-describedby="basic-addon1"
                    v-model="default_value.data"
                />
              </kt-form-group>
            </kt-col>
            <kt-col
                lg="12" md="12" xs="12"
                v-if="[
                  fieldTypesConstants.STRING,
                  fieldTypesConstants.NUMERIC,
                  fieldTypesConstants.TEXT,
                  fieldTypesConstants.DATE,
                ].includes(type)"
            >
              <kt-form-group>
                <kt-form-label for="placeholder">
                  {{ $t('online-factor.placeholder') }}
                </kt-form-label>
                <input
                    type="text"
                    class="form-control"
                    id="placeholder"
                    name="placeholder"
                    aria-describedby="basic-addon1"
                    v-model="placeholder.data"
                />
              </kt-form-group>
            </kt-col>
            <kt-col
                lg="12" md="12" xs="12"
                v-if="type === fieldTypesConstants.SELECT"
            >
              <div class="d-flex flex-column">
                <div class="d-flex justify-content-between align-items-center mb-4">
                  <kt-form-label for="options_list">
                    {{ $t('online-factor.options_list') }}
                  </kt-form-label>
                  <button
                      type="button"
                      class="btn btn-success mt-2"
                      @click="addOption"
                  >
                    افزودن گزینه جدید
                  </button>
                </div>
                <div v-for="(option, index) in options.data" :key="index" class="d-flex align-items-center my-1">
                  <input
                      name="options"
                      v-model="options.data[index]"
                      type="text"
                      class="form-control me-2"
                      :placeholder="'Option ' + (index + 1)"
                  />
                  <button
                      type="button"
                      class="btn btn-danger"
                      @click="removeOption(index)"
                  >
                    حذف
                  </button>
                </div>
              </div>
            </kt-col>
            <kt-col class="mt-4">
              <button id="submit-button" type="submit" class="btn btn-primary">افزودن فیلد</button>
            </kt-col>
          </kt-row>
        </kt-form-section>
      </div>
    </form>
  </kt-panel>
</template>

<script>
import mainContent from "@/components/main-content.vue";
import {fieldTypes, fieldTypesConstants} from "@/constants/CustomerFormatFieldTypes";
import toastr from "toastr";
import $ from 'jquery';
import {onlineFactorService} from "@/common/api.service";
import {fieldOptions, fieldOptionsConstants} from "@/constants/CustomerFormatFieldOptions";

export default {
  name: "Create_field" ,
  components: {
    'main-content': mainContent,
  },
  data() {
    return {
      fa_name: '',
      name: '',
      type: null,
      default_value: {
        type: 'default_value',
        data: '',
      },
      placeholder: {
        type: 'placeholder',
        data: '',
      },
      options: {
        type: 'options',
        data: []
      },
      default_status: {
        type: 'default_status',
        data: ''
      },
      disable: {
        type: 'disable',
        data: false
      }
    }
  },
  computed: {
    fieldTypes() {
      return fieldTypes
    },
    fieldTypesConstants() {
      return fieldTypesConstants
    },
    fieldStatus() {
      return fieldOptions
    },
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false
      }

      return toastr
    },

  },
  methods: {
    resetData(){
      this.fa_name = '',
      this.name = '',
      this.type = null,
      this.default_value = {
        type: 'default_value',
        data: '',
      },
      this.placeholder = {
        type: 'placeholder',
        data: '',
      },
      this.options = {
        type: 'options',
        data: []
      },
      this.default_status = {
        type: 'default_status',
        data: ''
      },
      this.disable = {
        type: 'disable',
        data: false
      }

    },
    removeOption(index) {
      if (this.options.data.length > 1) {
        this.options.data.splice(index, 1); // Removes option at the specified index
      }
    },
    addOption() {
      this.options.data.push(""); // Adds an empty string for a new option
    },
    submitRequest(e) {
      let form = $(e.target)
      let btn = $("#submit-button")

      form.validate({
        rules: {
          name: {
            required: true,
            minlength: 3
          },
          fa_name: {
            required: true,
            minlength: 3
          },
          type: {
            required: true,
          },
        }
      })

      if (this.type === fieldTypesConstants.SELECT && this.options.data.length < 2 ) {
        return this.toastr.error('برای فیلد انتخابی حداقل لیست انتخابی باید بیشتر از یک عدد باشد.')
      }

      if (!form.valid()) {
        return;
      }

      let details = []
      if (this.default_value.data)
        details.push(this.default_value)

      if (this.placeholder.data)
        details.push(this.placeholder)

      if (this.options.data.length > 0)
        details.push(this.options)

      if (this.disable.data)
        details.push(this.disable)

      if (this.default_status.data)
        details.push(this.default_status)

      let data = {
        name: this.name,
        fa_name: this.fa_name,
        type: this.type,
        details: details,
      }

      onlineFactorService.adminCreateField(data)
          .then(response => {
            this.$emit('close-modal')
            this.resetData()
            return this.toastr.success(response.data.message)
          })
          .catch(({ response }) => {
            this.toastr.error(response.data.message)
            for (let err in response.data.data) {
              this.toastr.error(response.data.data[err][0]);
            }
          })
    }
  }
}
</script>

<style scoped>

</style>